<div class="position-relative d-flex flex-column h-100  text-grey" 
  id="addNewJobDialogAbaqus"
  cdkDrag cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary="body"
  [cdkDragDisabled]="!toogleDialog">
  <div class="modal-header jobDialogHeader text-grey" cdkDragHandle>
  <h4 class="modal-title synchpc-primary" id="modal-title">
    Create {{ data.appName }} Job
  </h4>
  <i style="z-index: 1; margin-right: 1rem" class="bi bi-dash text-danger" [ngClass]="{
      'bi-dash-lg': !toogleDialog,
      'bi-fullscreen': toogleDialog,
      'minmax-dialog': toogleDialog
    }" color="warn" (click)="toogleDialogMinMax()" [title]="toogleDialog ? 'Maximize' : 'Minimize'"></i>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
</div>

<div class="modal-body jobDialogBody text-grey">
  <form name="dynamicJobForm" [formGroup]="dynamicJobForm" autocomplete="off" spellcheck="false">

    <div class="h-100 d-flex flex-column">
      <div class="flex-grow-1">
        <mat-accordion class="example-headers-align modified-mc-content">

          <mat-expansion-panel class="modified-mc-content" [expanded]="step === 0" (opened)="setStep(0)">

            <mat-expansion-panel-header>
              <mat-panel-title>
                Job and Application Settings
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field style="width: 48%">
              <mat-label>Job name prefix (Optional)</mat-label>
              <input matInput maxlength="36" placeholder="Job name prefix (Optional)"
                formControlName="dynamic_jobNamePrefix"
                matTooltip="Add a unique identifier that will be prefixed with job name. Only alphabets, numbers, '_', '-' , '.' , '@' allowed"
                [matAutocomplete]="auto" />
              <mat-autocomplete class="matAutoCompJob" autoActiveFirstOption #auto="matAutocomplete">
                <mat-option class="matOptionJob" *ngFor="let option of filteredOptions | async" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="dynamicJobForm.get('dynamic_jobNamePrefix').invalid">Name Entered is not
                Valid.</mat-error>
            </mat-form-field>

            <mat-form-field style="width: 48%; margin-left: 4%">
              <mat-label>Standard output file (Optional)</mat-label>
              <input matInput maxlength="20" placeholder="Standard output file (Optional)"
                matTooltip="Standard output and standard errors will be logged in this file. Only alphabets, numbers, '_', '-' , '.' allowed"
                formControlName="dynamic_standardOutputFile" />
              <mat-error *ngIf="dynamicJobForm.get('dynamic_standardOutputFile').invalid">Name Entered is not
                Valid.</mat-error>
            </mat-form-field>

            <mat-form-field style="width: 48%" [floatLabel]="useFixedNoOfCores ? 'always' : 'auto'">
              <mat-label>Number of Cores (Max)</mat-label>
              <mat-select *ngIf="useFixedNoOfCores" formControlName="dynamic_numberOfCoresMax" required
                [(ngModel)]="maximumCores" (ngModelChange)="checkMaxCores()">
                <mat-option *ngFor="let staticCore of staticCores" [value]="staticCore">
                  {{ staticCore }}
                </mat-option>
              </mat-select>
              <input matInput type="number"
                (mousewheel)="$event.preventDefault()" min="1" #maxInputVal *ngIf="!useFixedNoOfCores"
                placeholder="Number of Cores* (Max)" formControlName="dynamic_numberOfCoresMax"
                matTooltip="Add number of cores on which job should run. Maximum cores are required, Minimum cores are optional. If given Max cores are not available then given Min cores will be used for job. If those are also not available, job will be kept in queue."
                matTooltipClass="example-tooltip-red" [(ngModel)]="maximumCores" (ngModelChange)="checkMaxCores()" />
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_numberOfCoresMax').touched &&
          dynamicJobForm.get('dynamic_numberOfCoresMax').errors?.required
        ">Enter Value of Maximum no. of Cores.</mat-error>
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_numberOfCoresMax').touched &&
          dynamicJobForm.get('dynamic_numberOfCoresMax').errors?.min
        ">Value of Maximum no. of Cores should not be in negative.</mat-error>
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_numberOfCoresMax').touched &&
          dynamicJobForm.get('dynamic_numberOfCoresMax').errors?.max
        ">
                Value of Maximum no. of Cores exceeds total no. of cores
                available ({{maximumCoresAllowed}}).
              </mat-error>
            </mat-form-field>

            <mat-form-field class="d-none" style="width: 48%; margin-left: 4%">
              <mat-label>Number of Cores (Min)</mat-label>
              <mat-select *ngIf="useFixedNoOfCores" [(ngModel)]="minimumCores" (ngModelChange)="checkMinCores()"
                formControlName="dynamic_numberOfCoresMin" required>
                <mat-option *ngFor="let staticCore of staticCores" [value]="staticCore">
                  {{ staticCore }}
                </mat-option>
              </mat-select>
              <input matInput type="number"
                (mousewheel)="$event.preventDefault()" min="1" #minInputVal *ngIf="!useFixedNoOfCores"
                placeholder="Number of Cores (Min)"
                matTooltip="Add number of cores on which job should run. Maximum cores are required, Minimum cores are optional. If given Max cores are not available then given Min cores will be used for job. If those are also not available, job will be kept in queue."
                formControlName="dynamic_numberOfCoresMin" [(ngModel)]="minimumCores"
                (ngModelChange)="checkMinCores()" />
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_numberOfCoresMin').touched &&
          dynamicJobForm.get('dynamic_numberOfCoresMin').errors?.required
        ">Enter Value of Minimum no. of Cores.</mat-error>
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_numberOfCoresMin').touched &&
          dynamicJobForm.get('dynamic_numberOfCoresMin').errors?.invalidCore
        ">
                Minimum cores should be lesser than or equal to Maximum
                Cores.
              </mat-error>
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_numberOfCoresMin').touched &&
          dynamicJobForm.get('dynamic_numberOfCoresMin').errors?.min
        ">Value of Minimum no. of Cores should not be in negative.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" style="width: 48%; margin-left: 4%" matTooltip="Select Queue"
              matTooltipPosition="above">
              <mat-label>Select Node Group (Queue)</mat-label>
              <mat-select formControlName="dynamic_NodeGroup" multiple>
                <mat-option [disabled]="isNodeGroupDisabled(group)" *ngFor="let group of groups" [value]="group">
                  {{ group }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_NodeGroup').touched &&
          dynamicJobForm.get('dynamic_NodeGroup').errors
        ">Please Select Node Group (Queue).</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" style="width: 48%;"
              [ngClass]="!makeJobTagMandatoryFlag && !customTagName ? 'me-5' : 'margin-left-with-CustomTag'">
              <mat-label>Select App Version</mat-label>
              <mat-select formControlName="dynamic_versionControl">
                <mat-option *ngFor="let version of appVersion" [value]="version">
                  {{ version.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="width: 48%" appearance="fill" matTooltip="Enter project name"
              matTooltipPosition="above" *ngIf="makeJobTagMandatoryFlag">
              <mat-label>Add Tag</mat-label>
              <input type="text" placeholder="Enter tag e.g. Project name" matInput formControlName="dynamic_Tag" />
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_Tag').errors?.required
        ">Please Add Tag</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" style="width: 48%;" [hidden]="!customTagName"
              [ngClass]="makeJobTagMandatoryFlag ? 'margin-left-with-CustomTag' : 'margin-left'">
              <mat-label>{{ customTagName }}</mat-label>
              <input type="text" placeholder="{{ customTagName }}" matInput formControlName="dynamic_customTag"
                [matAutocomplete]="autoCustomTag" />
              <mat-autocomplete #autoCustomTag="matAutocomplete">
                <mat-option *ngFor="let autoCustomTag of customTagValues" [value]="autoCustomTag">
                  {{ autoCustomTag }}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_customTag').errors?.required
        "></mat-error>
            </mat-form-field>

            <div *ngIf="formData" style="display: flex; flex-wrap: wrap; margin-bottom: 2rem">
              <div *ngFor="let control of formData.Controls"
                [ngStyle]="{ width: control.Type == 'inputFile' ? '100%' : '50%' }">
                <div [ngStyle]="{ marginLeft: control.Type == 'inputFile' ? '0%' : '0%' }" style="margin-bottom: 1rem">
                  <!-- dropdown -->
                  <mat-form-field *ngIf="control.Type == 'dropdown'" appearance="fill" style="width: 98%">
                    <mat-label>{{ control.Label }}</mat-label>
                    <mat-select [formControlName]="control.Name">
                      <mat-option *ngFor="let val of control.AddValue" [value]="val">
                        {{ val }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- checkbox -->
                  <mat-checkbox *ngIf="control.Type == 'checkbox'" [formControlName]="control.Name" class="mt-2"
                    [title]="control.Label" style="display: inline-flex">
                    {{ control.Label }}
                  </mat-checkbox>

                  <!-- input text -->
                  <mat-form-field style="width: 96%" *ngIf="['textbox'].includes(control.Type)">
                    <mat-label>{{ control.Label }}</mat-label>
                    <input matInput [placeholder]="control.Label" type="text" [formControlName]="control.Name"
                      [value]="control.Value" [matTooltip]="control.tooltip" />
                    <mat-error *ngIf="dynamicJobForm.get(control.Name).invalid">
                      {{
                      control.ErrorMsg
                      }}
                    </mat-error>
                  </mat-form-field>

                  <!-- upload files -->
                  <mat-form-field *ngIf="control.Type === 'inputFile'"
                                  style="width: 48%; margin-top: 0.4rem; background: var(--s-menuHover-color)">
                    <mat-label>{{control.Label}}</mat-label>
                    <input readonly matInput [formControlName]="control.Name"
                           (ngModelChange)="updateJobName($event)" matTooltip="Select input file"
                           matTooltipClass="example-tooltip-red" />
                    <mat-error *ngIf="
                dynamicJobForm.get(control.Name).touched &&
                dynamicJobForm.get(control.Name).errors?.required
              ">{{ control.ErrorMsg }}</mat-error>
                  </mat-form-field>

                  <!-- upload files -->
                  <div *ngIf="control.Type === 'inputFile'" style="display: inline-flex; align-items: center">
                    <div style="height: 22px; margin-left: 5px; width: 18px">
                      <a title="Remove" style="cursor: pointer" *ngIf="
                  dynamicJobForm.get(control.Name).value != null &&
                  dynamicJobForm.get(control.Name).value != ''
                " (click)="removeFile(control.Name)">
                        <span class="bi bi-x-lg text-danger" aria-hidden="true" style="color: red; font-size: 18px">
                        </span>
                      </a>
                    </div>
                    <input type="button" value="Use SyncStore" (click)="loadSyncStoreFileTree(control.Name)"
                      id="inputSyncStoreSelectFile" class="uploadBtn"
                      style="font-size: 12px; margin-left: 5px; outline: none" />
                      <input
                      type="file"
                      [name]="control.Name"
                      [id]="control.Name"
                      #dynamicBtnWorkStore
                      (click)="onFileChange(control.Name)"
                      style="display: none; font-size: 12px; width: 90px"
                      ng2FileSelect
                      (onFileSelected)="startNg2Upload($event, control.Name)"
                      [uploader]="uploader"
                    />
                    <!-- <label class="dynamicUploadBtn" [for]="control.Name">Upload File</label> -->
                      <button
                      type="button"
                      #lDynaRestartFile
                      class="uploadBtn pull-right"
                      style="margin-left: 5px; outline: none"
                      [for]="control.Name"
                      (click)="dynamicBtnWorkStore.click()"
                    >
                      <span class="bi bi-cloud-arrow-up-fill"></span>
                      Upload File
                    </button>
                    <p *ngIf="
                jobInputIds[control.Name] != null && cloudType == 'On-Premise'
              " style="margin: 0 0 0 15px !important" class="uploadPercentage">
                      {{ jobInputIds[control.Name] === 'Starting' ? 'Upload : Starting...' : 'Uploaded : ' + jobInputIds[control.Name] + '%' }}
                    </p>
                    <p *ngIf="
                jobInputIds[control.Name] != null && cloudType != 'On-Premise'
              " style="margin: 0 0 0 15px !important" class="uploadPercentage">
                      {{ jobInputIds[control.Name] }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div style="margin-top:1%">
              <table id="dynamic_inputFileTable" class="table table-bordered additionalInputs" style="
          overflow-y: scroll;
          height: 150px;
          display: block;
          background-color: #f5f5f5;
          padding: 0px;
        ">
                <tbody>
                  <tr>
                    <td style="width: 10%">
                      <span>Additional Input Files :</span>
                    </td>
                    <td style="width: 35%; text-align: end">
                      <button type="button" id="btnUploadFile" title="Select and upload files to working directory"
                        class="uploadBtn pull-right" style="outline: none" (click)="openFileEditor()"
                        *ngIf="isHeadNodeLinux">
                        <span class="bi bi-pencil"></span>
                        New File
                      </button>
                      <input multiple type="file" #dynamicBtnWorkStore (click)="onFileChange('dynamicBtnWorkStore')"
                        style="display: none; font-size: 12px; width: 90px" (onFileSelected)="startNg2Upload($event)"
                        ng2FileSelect [uploader]="uploader" />
                      <input type="button" name="dynamicBtnSyncStore" value="Use SyncStore"
                        (click)="loadSyncStoreFileTree()" id="dynamicBtnSyncStore" class="uploadBtn pull-right"
                        style="font-size: 12px; outline: none" />
                      <button type="button" id="btnUploadFile" title="Select and upload files to working directory"
                        class="uploadBtn pull-right" style="outline: none" (click)="dynamicBtnWorkStore.click()">
                        <span class="bi bi-cloud-arrow-up-fill"></span>
                        Upload File(s)
                      </button>
                    </td>
                  </tr>
                  <tr *ngFor="let inputFile of jobAdditionalInputFiles; let i = index">
                    <td><span>File Name :</span></td>
                    <td>
                      <span title="{{ inputFile.path }}">{{ inputFile.name }}</span>
                      <button #cancelUpload title="Remove File" type="button" style="margin-left: 5px"
                        id="cancel{{ i }}" (click)="removeItem(inputFile)">
                        <span class="bi bi-x-lg text-danger" style="color: brown"></span>
                      </button>
                      <button #editFile title="Edit File" type="button" style="margin-left: 5px" id="edit{{ i }}"
                        (click)="editItem(inputFile)"
                        *ngIf="inputFile.isUploadCompleted && inputFile.type == 'file' && isHeadNodeLinux">
                        <span class="bi bi-pencil-square text-danger" style="color: brown"></span>
                      </button>
                      <span *ngIf="
                          inputFile.value != undefined && cloudType != 'Microsoft Azure'
                        " class="uploadPercentage">{{ inputFile.value === 'Starting' ? 'Upload : Starting...' : 'Uploaded : ' + inputFile.value + '%' }}</span>
                      <span *ngIf="
                          inputFile.value != undefined && cloudType == 'Microsoft Azure'
                        " class="uploadPercentage">
                          <ng-container *ngIf="inputFile.isUploadCompleted; else showValue">
                            Upload Completed
                          </ng-container>
                          <ng-template #showValue>
                            {{ inputFile.value }}
                          </ng-template>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </mat-expansion-panel>

          <mat-expansion-panel class="modified-mc-content" [expanded]="step === 2" (opened)="setStep(2)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Additional Settings
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field style="width: 48%">
              <mat-label>Start Command (Optional)</mat-label>
              <input matInput placeholder="Start Command (Optional)"
                     matTooltip="Add command that will run before job execution" formControlName="dynamic_startCommand" />
            </mat-form-field>

            <mat-form-field style="width: 48%; margin-left: 4%">
              <mat-label>End Command (Optional)</mat-label>
              <input matInput placeholder="End Command (Optional)" formControlName="dynamic_endCommand"
                     matTooltip="Add command for post-processing" />
            </mat-form-field>

            <mat-form-field style="width: 48%" matTooltip="Memory Per CPU (Optional In GB). Enter numbers only."
                            matTooltipPosition="above">
              <mat-label>Memory Per CPU (Optional, In GB)</mat-label>
              <input matInput type="number"
                     (mousewheel)="$event.preventDefault()" placeholder="Memory Per CPU (Optional, In GB)"
                     formControlName="dynamic_memoryPerCpu" />
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_memoryPerCpu').touched &&
          dynamicJobForm.get('dynamic_memoryPerCpu').errors?.pattern
        ">
                Please enter memory per CPU (in GB) in positive number only, e.g
                1.
              </mat-error>
            </mat-form-field>

            <mat-form-field style="width: 48%; margin-left: 4%" matTooltip="Wallclock Time (Optional, In Min)"
                            matTooltipPosition="above">
              <mat-label>Wallclock Time (Optional, In Min)</mat-label>
              <input matInput type="number"
                     (mousewheel)="$event.preventDefault()" placeholder="Wallclock Time (Optional, In Min)"
                     formControlName="dynamic_wallclockTime" />
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_wallclockTime').touched &&
          dynamicJobForm.get('dynamic_wallclockTime').errors?.pattern
        ">
                Please enter Wallclock Time (In Min), e.g 30 or 60 or 90. Enter
                positive numbers only
              </mat-error>
            </mat-form-field>

            <mat-form-field style="width: 48%;" matTooltip="Enter tasks per node." matTooltipPosition="above">
              <mat-label>Tasks per node</mat-label>
              <input matInput type="number"
                     (mousewheel)="$event.preventDefault()" min="0" placeholder="Tasks per node"
                     formControlName="dynamic_taskPerNode" />
              <mat-error *ngIf="
                    dynamicJobForm.get('dynamic_taskPerNode').touched &&
                    dynamicJobForm.get('dynamic_taskPerNode').errors?.pattern
                    ">
                Please add tasks per node.
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 48%; margin-left: 4%"
                            matTooltip="If true, job will have exclusive access to the node, else job can share nodes with other jobs."
                            matTooltipPosition="above">
              <mat-label>Is Job Exclusive ?</mat-label>
              <mat-select formControlName="dynamic_isExclusive" required>
                <mat-option value="0">True</mat-option>
                <mat-option value="1">False</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="width: 48%;"
                            matTooltip="Minimum Scratch Space (Optional, In GB). Enter numbers only." matTooltipPosition="above">
              <mat-label>Minimum Scratch Space (Optional, In GB)</mat-label>
              <input matInput type="number"
                     (mousewheel)="$event.preventDefault()" placeholder="Minimum Scratch Space (Optional, In GB)"
                     formControlName="dynamic_MinScratchSpace" />
              <mat-error *ngIf="
      dynamicJobForm.get('dynamic_MinScratchSpace').touched &&
      dynamicJobForm.get('dynamic_MinScratchSpace').errors?.pattern
    ">Please enter minimum scratch space (in GB), e.g 1.</mat-error>
            </mat-form-field>

            <mat-form-field style="width: 48%; margin-left: 4%;" appearance="fill">
              <mat-label>Schedule Job Submission (Optional)</mat-label>
              <input matInput
                     [min]="minDate"
                     [max]="maxDate"
                     [owlDateTimeTrigger]="dt8"
                     [owlDateTime]="dt8"
                     formControlName="dynamic_ScheduleTime">
              <owl-date-time #dt8></owl-date-time>
              <mat-error *ngIf="
                dynamicJobForm.get('dynamic_ScheduleTime').touched &&
                dynamicJobForm.get('dynamic_ScheduleTime').errors
              ">Please provide correct date and time.</mat-error>
            </mat-form-field>

            <mat-form-field style="width: 48%;" appearance="fill" matTooltip="Enter project name"
                            matTooltipPosition="above" *ngIf="!makeJobTagMandatoryFlag">
              <mat-label>Add Tag</mat-label>
              <input type="text" placeholder="Enter tag e.g. Project name" matInput formControlName="dynamic_Tag" />
              <mat-error *ngIf="dynamicJobForm.get('dynamic_Tag').errors?.required">Please Add Tag</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill"
                            [ngClass]="!makeJobTagMandatoryFlag ? 'margin-left' : 'margin-left-with-CustomTag'">
              <mat-label>Select Priority</mat-label>
              <mat-select formControlName="dynamic_Priority" required>
                <mat-option *ngFor="let priority of priorities" [value]="priority">
                  {{ priority }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="
          dynamicJobForm.get('dynamic_Priority').touched &&
          dynamicJobForm.get('dynamic_Priority').errors
        ">Please Select Priority.</mat-error>
            </mat-form-field>

            <mat-form-field style="width: 48%"
                            matTooltip="Enter path where job data will be copied to after job completion. Default : {{ outDirMessage }}"
                            matTooltipPosition="above">
              <mat-label>Job Output Directory</mat-label>
              <input matInput type="text" formControlName="dynamic_outputDirectory"
                     placeholder="Default : {{ outDirMessage }}" />
            </mat-form-field>
            <mat-form-field style="width: 48%; margin-left: 4%"
                            appearance="fill"
                            matTooltip="Select specific nodes to run your job on"
                            matTooltipPosition="above">
              <mat-label>Select Specific Nodes (Optional)</mat-label>
              <mat-select formControlName="dynamic_SelectedNodes" multiple (selectionChange)="onDynamicNodeSelectionChange($event)">
                <mat-option value="Default">
                  Any
                </mat-option>
                <mat-option *ngFor="let node of availableNodes" [value]="node.vmName">
                  {{ node.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <h3>Dependencies Settings</h3>
            <div class="depend" style="width: 100%">
              <mat-form-field appearance="fill">
                <mat-label>Dependency</mat-label>
                <mat-select formControlName="dependecy">
                  <mat-option value="None">None</mat-option>
                  <mat-option value="after">after</mat-option>
                  <mat-option value="afterany">afterany</mat-option>
                  <mat-option value="afterburstbuffer">afterburstbuffer</mat-option>
                  <mat-option value="aftercorr">aftercorr</mat-option>
                  <mat-option value="afternotok">afternotok</mat-option>
                  <mat-option value="afterok">afterok</mat-option>
                  <mat-option value="singleton">singleton</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="example-full-width" style="margin-left:5%">
                <mat-label>Input Job Id</mat-label>
                <input type="text" formControlName="jobID" matInput>
                <mat-error *ngIf="
                      dynamicJobForm.get('jobID').touched &&
                      dynamicJobForm.get('jobID').errors?.required
                      ">Please Enter ':' separated Job ID</mat-error>
              </mat-form-field>
            </div>

            <mat-checkbox formControlName="dynamic_BackupData" style="margin-left: 32%">
              Copy output data of job to Syncstore
            </mat-checkbox>
            <mat-checkbox formControlName="dynamic_keepWorkStoreData" style="margin-left: 32%">
              Keep job data in workstore after job completion
            </mat-checkbox>

          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>


    <!--<mat-checkbox
    title="Stop all compute nodes after job completion"
    formControlName="dynamic_autoShut"
    style="margin-left: 32%"
    >Stop all compute nodes after job completion</mat-checkbox
  >-->

    <div style="display: flex; display: none">
      <mat-checkbox formControlName="dynamic_jobSchedule" class="well well-sm" title="Schedule this Job"
        style="padding-left: 32%; display: inline-flex">
        Schedule this job for later,
      </mat-checkbox>
      <input matInput style="
          margin-left: 2%;
          color: var(--s-primary-color);
          width: 28%;
          border-bottom: 1px solid black;
        " formControlName="dynamic_customDate" placeholder="Job will be executed at the given time."
        type="datetime-local" value="" [min]="todayDate" [max]="maxDate" />
    </div>
  </form>
</div>

<div class="modal-footer jobDialogFooter text-grey">
  <div class="w-100" [ngClass]="{'d-none' : cloudType != 'On-Premise'}">
    <mat-checkbox [(ngModel)]="autoSubmitAfterUpload" style="margin-left: 32%"
      title="If true, job will be automatically submitted when all the uploads are completed. Note: Make sure all fields are correctly filled, if fields contains error the job will not be submitted.">
      Automatically submit job after upload completion. </mat-checkbox>
  </div>
  <div class="w-100 d-flex align-items-center">
    <div class="d-flex w-50 align-items-center">
      <mat-form-field class="flex-grow-1">
        <mat-label>Job template name (Optional)</mat-label>
        <input type="text" name="jobTemplateName" [(ngModel)]="jobTemplateNameValue"
          title="Enter template name to save and use these settings later." matInput />
      </mat-form-field>

      <button class="default-btn ms-2" style="border: 1px solid #0072c6" title="Save Template"
        (click)="jobTemplateNameValue && saveJobTemplate()">
        <span class="bi bi-journal-code"></span> Save
      </button>
    </div>
    <div class="d-flex d-flex justify-content-end w-50">
      <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Close</button>
      <button type="button" class="btn btn-primary ms-2"
        [title]="!isHeadnodeActive ? 'Job cannot be submitted. Headnode not active.' : 'Submit Job'"
        [disabled]="isUploadActive || isHeadnodeActive == false || autoSubmitAfterUpload" (click)="onSubmit()">
        Submit
      </button>
    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0)" size="default" zIndex="1" color="var(--s-primary-color)" type="ball-spin"
  [fullScreen]="false" name="resubmitJob">
  <p class="pleaseWait text-grey">Please wait ...</p>
</ngx-spinner>
</div>
